<!-- Agency Information -->
<div *ngIf="loadSpinner || !form" class="k-d-flex k-w-full k-justify-content-center">
  <kendo-loader type="converging-spinner" size="large"></kendo-loader>
</div>
<div *ngIf="form">
  <form [formGroup]="form">

    <div class="capacity-container">
      <div class="k-d-flex k-justify-content-between">
        <div class="k-d-flex k-flex-basis-1/2">
          <p class="!k-font-semibold !k-my-2">
            View Capacity Information for:
          </p>
          <kendo-dropdownlist [data]="agencyLocation" class="k-flex-1 !k-ml-2" size="small"
            [textField]="'agencyLocation'" [valueField]="'agencyLocationSK'" (selectionChange)="selectionChange($event)"
            formControlName="location"></kendo-dropdownlist>
        </div>
        <button kendoButton size="small" rounded="large" fillMode="solid" (click)="onEditCapacity()">
          Edit Capacity Details
        </button>
      </div>


      <div class="main-div k-mt-5">
        <kendo-tilelayout [columns]="2" class="!k-p-0">
          <kendo-tilelayout-item [col]="1" [rowSpan]="2" style="width: 120%;margin-left: 10px;">
            <div class="title display !k-p-4">
              <h5 class="!k-m-0 header">Location Information</h5>
            </div>
            <div class="h-seperator"></div>
            <div class="body k-p-4">
              <ng-container *ngIf="isEdit">
                <div class="k-d-inline-flex k-w-full form-container k-mt-4">
                  <kendo-formfield class="form-field">
                    <kendo-label text="Service: Start Time">
                      <kendo-timepicker id="serviceStartTime" [max]="getTime('serviceEndTime') || startTimePickerMax"
                        formControlName="serviceStartTime" class="additional-info"
                        [steps]="{ hour: 1, minute: 30 }"></kendo-timepicker>
                    </kendo-label>
                  </kendo-formfield>
                  <kendo-formfield class="form-field">
                    <kendo-label text="Service: End Time">
                      <kendo-timepicker id="serviceEndTime" [min]="getTime('serviceStartTime') || endTimePickerMin"
                        formControlName="serviceEndTime" [steps]="{ hour: 1, minute: 30 }"
                        class="additional-info"></kendo-timepicker>
                    </kendo-label>
                  </kendo-formfield>
                  <kendo-formfield class="form-field">
                    <kendo-label text="Lunch: Start Time">
                      <kendo-timepicker [steps]="{ hour: 1, minute: 30 }" [max]="getTime('lunchEndTime')"
                        id="lunchStartTime" formControlName="lunchStartTime" class="additional-info"></kendo-timepicker>
                    </kendo-label>
                  </kendo-formfield>
                  <kendo-formfield class="form-field">
                    <kendo-label text="Lunch: End Time">
                      <kendo-timepicker id="lunchEndTime" [steps]="{ hour: 1, minute: 30 }"
                        [min]="getTime('lunchStartTime')" formControlName="lunchEndTime"
                        class="additional-info"></kendo-timepicker>
                    </kendo-label>
                  </kendo-formfield>
                </div>
                <div class="k-mt-4">
                  <div class="k-d-inline-flex k-w-full form-container k-mt-4 wait-time-row">

                    <!-- Number -->
                    <kendo-formfield class="form-field half-width">
                      <kendo-label text="Average Appointment Wait Time - Number of">
                        <kendo-numerictextbox formControlName="averageWaitTime" [min]="1" [max]="getMaxWaitTime()"
                          format="##" class="additional-info">
                        </kendo-numerictextbox>
                      </kendo-label>
                      <kendo-formerror *ngIf="form.get('averageWaitTime')?.errors?.['max']">
                        Value must be between 1 and {{ getMaxWaitTime() }}
                      </kendo-formerror>
                    </kendo-formfield>

                    <!-- Unit -->
                    <kendo-formfield class="form-field half-width">
                      <kendo-label text="Average Appointment Wait Time - Unit of Time">
                        <kendo-dropdownlist formControlName="dateFrequency" [data]="frequencyInterval"
                          textField="description" valueField="id" [valuePrimitive]="true" class="additional-info">
                        </kendo-dropdownlist>
                      </kendo-label>
                    </kendo-formfield>

                  </div>
                </div>
              </ng-container>
              <ng-container *ngIf="!isEdit">
                <div class="k-d-flex">
                  <div class="k-flex-1">
                    <span class="text-secondary">Service Timing Hours</span>
                    <p class="!k-mt-1 !k-mb-0">{{entityData?.serviceStartTime| date: "h:mm a"
                      }} -
                      {{entityData?.serviceEndTime| date: "h:mm a" }}</p>
                  </div>
                  <div class="k-flex-1">
                    <span class="text-secondary">Lunch Time</span>
                    <p class="!k-mt-1 !k-mb-0">{{entityData?.lunchStartTime| date: "h:mm a" }}
                      -
                      {{entityData?.lunchEndTime| date: "h:mm a" }}</p>
                  </div>
                  <div class="k-flex-1">
                    <span class="text-secondary">Average Appointment Wait Time</span>
                    <p class="!k-mt-1 !k-mb-0">
                      {{entityData?.averageWaitTime || ''}}
                      {{entityData?.dateFrequency ? waitTimeMap.get(entityData?.dateFrequency) + '(s)' : ''}}
                    </p>
                  </div>
                </div>
              </ng-container>

              <div class="schedule-table">
                <table class="grid-assessments k-w-full assessments-table">
                  <thead class="k-text-left" style="background-color: #eaf1fd;">
                    <th scope="col" style="width: 200px;"><span class="k-sr-only">Schedule item</span></th>
                    <th scope="col">Monday</th>
                    <th scope="col">Tuesday</th>
                    <th scope="col">Wednesday</th>
                    <th scope="col">Thursday</th>
                    <th scope="col">Friday</th>
                    <th scope="col">Saturday</th>
                    <th scope="col">Sunday</th>
                  </thead>
                  <tbody>
                    <tr [class.tr-1-border]="!isEdit">
                      <td style="background-color: #eaf1fd; font-weight: bold; ">Total
                        Appointments</td>
                      <td>
                        <kendo-numerictextbox [min]="0" format="##" formControlName="totalAppointmentsMonday"
                          *ngIf="isEdit"></kendo-numerictextbox>
                        <p class="k-text-center" *ngIf="!isEdit">
                          {{entityData?.totalAppointmentsMonday}}</p>
                      </td>
                      <td>
                        <kendo-numerictextbox [min]="0" format="##" formControlName="totalAppointmentsTuesday"
                          *ngIf="isEdit"></kendo-numerictextbox>
                        <p class="k-text-center" *ngIf="!isEdit">
                          {{entityData?.totalAppointmentsTuesday}}</p>
                      </td>
                      <td>
                        <kendo-numerictextbox [min]="0" format="##" formControlName="totalAppointmentsWednesday"
                          *ngIf="isEdit"></kendo-numerictextbox>
                        <p class="k-text-center" *ngIf="!isEdit">
                          {{entityData?.totalAppointmentsWednesday}}</p>
                      </td>
                      <td>
                        <kendo-numerictextbox [min]="0" format="##" formControlName="totalAppointmentsThursday"
                          *ngIf="isEdit"></kendo-numerictextbox>
                        <p class="k-text-center" *ngIf="!isEdit">
                          {{entityData?.totalAppointmentsThursday}}</p>
                      </td>
                      <td>
                        <kendo-numerictextbox [min]="0" format="##" formControlName="totalAppointmentsFriday"
                          *ngIf="isEdit"></kendo-numerictextbox>
                        <p class="k-text-center" *ngIf="!isEdit">
                          {{entityData?.totalAppointmentsFriday}}</p>
                      </td>
                      <td>
                        <kendo-numerictextbox [min]="0" format="##" formControlName="totalAppointmentsSaturday"
                          *ngIf="isEdit"></kendo-numerictextbox>
                        <p class="k-text-center" *ngIf="!isEdit">
                          {{entityData?.totalAppointmentsSaturday}}</p>
                      </td>
                      <td>
                        <kendo-numerictextbox [min]="0" format="##" formControlName="totalAppointmentsSunday"
                          *ngIf="isEdit"></kendo-numerictextbox>
                        <p class="k-text-center" *ngIf="!isEdit">
                          {{entityData?.totalAppointmentsSunday}}</p>
                      </td>
                    </tr>

                    <tr>
                      <td style="background-color: #eaf1fd; font-weight: bold;">Total Staff with
                        Bilingual Evaluators</td>
                      <td>
                        <kendo-numerictextbox *ngIf="isEdit" [min]="0" format="##"
                          formControlName="totalStaffMonday"></kendo-numerictextbox>
                        <p class="k-text-center" *ngIf="!isEdit">
                          {{entityData?.totalStaffMonday}}</p>
                      </td>
                      <td>
                        <kendo-numerictextbox *ngIf="isEdit" [min]="0" format="##"
                          formControlName="totalStaffTuesday"></kendo-numerictextbox>
                        <p class="k-text-center" *ngIf="!isEdit">
                          {{entityData?.totalStaffTuesday}}</p>
                      </td>
                      <td>
                        <kendo-numerictextbox *ngIf="isEdit" [min]="0" format="##"
                          formControlName="totalStaffWednesday"></kendo-numerictextbox>
                        <p class="k-text-center" *ngIf="!isEdit">
                          {{entityData?.totalStaffWednesday}}</p>
                      </td>
                      <td>
                        <kendo-numerictextbox *ngIf="isEdit" [min]="0" format="##"
                          formControlName="totalStaffThursday"></kendo-numerictextbox>
                        <p class="k-text-center" *ngIf="!isEdit">
                          {{entityData?.totalStaffThursday}}</p>
                      </td>
                      <td>
                        <kendo-numerictextbox *ngIf="isEdit" [min]="0" format="##"
                          formControlName="totalStaffFriday"></kendo-numerictextbox>
                        <p class="k-text-center" *ngIf="!isEdit">
                          {{entityData?.totalStaffFriday}}</p>
                      </td>
                      <td>
                        <kendo-numerictextbox *ngIf="isEdit" [min]="0" format="##"
                          formControlName="totalStaffSaturday"></kendo-numerictextbox>
                        <p class="k-text-center" *ngIf="!isEdit">
                          {{entityData?.totalStaffSaturday}}</p>
                      </td>
                      <td>
                        <kendo-numerictextbox *ngIf="isEdit" [min]="0" format="##"
                          formControlName="totalStaffSunday"></kendo-numerictextbox>
                        <p class="k-text-center" *ngIf="!isEdit">
                          {{entityData?.totalStaffSunday}}</p>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>

            </div>
          </kendo-tilelayout-item>
          <kendo-tilelayout-item [col]="2" [rowSpan]="2" style="margin-left: 190px;">
            <div class="title !k-p-4">
              <h5 class="!k-m-0 header">Servicing Information</h5>
            </div>

            <div class="h-seperator"></div>

            <div class="body k-p-4">
              <ng-container *ngIf="isEdit">
                <div>
                  <kendo-formfield showHints="always">
                    <kendo-label text="Are you operating your approved MDE program?">
                      <kendo-dropdownlist formControlName="operatingMDE" [data]="operatingMDEProgram"
                        textField="description" valueField="id" [valuePrimitive]="true" class="additional-info">
                      </kendo-dropdownlist>
                    </kendo-label>
                  </kendo-formfield>
                </div>
                <div>
                  <kendo-formfield showHints="always">
                    <kendo-label text="Language of Service">
                      <kendo-multiselect [data]="referenceData.language" textField="description" [valuePrimitive]="true"
                        valueField="id" formControlName="languages" class="additional-info">
                      </kendo-multiselect>
                    </kendo-label>
                  </kendo-formfield>
                </div>
                <div>
                  <p>Bilingual MDE Service Method(s)</p>
                  <div class="k-mt-2">
                    <input type="checkbox" size="medium" kendoCheckBox formControlName="bilingualPsychologist" />
                    <kendo-label class="k-checkbox-label" text="">
                      Bilingual Psychologist
                    </kendo-label>
                  </div>
                  <div class="k-mt-2">
                    <input type="checkbox" size="medium" kendoCheckBox formControlName="bilingualInterpreter" />
                    <kendo-label class="k-checkbox-label" text="">
                      Through an Interpreter
                    </kendo-label>
                  </div>
                </div>
                <div>
                  <p>Evaluation Setting</p>
                  <div class="k-mt-2">
                    <input type="checkbox" size="medium" kendoCheckBox formControlName="onSite" />
                    <kendo-label class="k-checkbox-label" text="">
                      On-Site
                    </kendo-label>
                  </div>
                  <div class="k-mt-2">
                    <input type="checkbox" size="medium" kendoCheckBox formControlName="offSite" />
                    <kendo-label class="k-checkbox-label" text="">
                      Off-Site
                    </kendo-label>
                  </div>
                </div>
                <div>
                  <p>Borough(s) Serviced</p>
                  <div class="k-mt-2">
                    <input type="checkbox" size="medium" kendoCheckBox formControlName="serviceManhattan" />
                    <kendo-label class="k-checkbox-label" text="">
                      Manhattan
                    </kendo-label>
                  </div>
                  <div class="k-mt-2">
                    <input type="checkbox" size="medium" kendoCheckBox formControlName="serviceBronx" />
                    <kendo-label class="k-checkbox-label" text="">
                      Bronx
                    </kendo-label>
                  </div>
                  <div class="k-mt-2">
                    <input type="checkbox" size="medium" kendoCheckBox formControlName="serviceBrooklyn" />
                    <kendo-label class="k-checkbox-label" text="">
                      Brooklyn
                    </kendo-label>
                  </div>
                  <div class="k-mt-2">
                    <input type="checkbox" size="medium" kendoCheckBox formControlName="serviceQueens" />
                    <kendo-label class="k-checkbox-label" text="">
                      Queens
                    </kendo-label>
                  </div>
                  <div class="k-mt-2">
                    <input type="checkbox" size="medium" kendoCheckBox formControlName="serviceStatenIsland" />
                    <kendo-label class="k-checkbox-label" text="">
                      Staten Island
                    </kendo-label>
                  </div>
                </div>
                <div>
                  <p>Type of Evaluation(s)</p>
                  <div class="k-mt-2">
                    <input type="checkbox" size="medium" kendoCheckBox formControlName="sheval" />
                    <kendo-label class="k-checkbox-label" text="">
                      Social History Evaluation
                    </kendo-label>
                  </div>
                  <div class="k-mt-2">
                    <input type="checkbox" size="medium" kendoCheckBox formControlName="psychoEval" />
                    <kendo-label class="k-checkbox-label" text="">
                      Psychological Assessment
                    </kendo-label>
                  </div>
                  <div class="k-mt-2">
                    <input type="checkbox" size="medium" kendoCheckBox formControlName="counseling" />
                    <kendo-label class="k-checkbox-label" text="">
                      Counseling
                    </kendo-label>
                  </div>
                  <div class="k-mt-2">
                    <input type="checkbox" size="medium" kendoCheckBox formControlName="pteval" />
                    <kendo-label class="k-checkbox-label" text="">
                      Physical Therapy
                    </kendo-label>
                  </div>
                  <div class="k-mt-2">
                    <input type="checkbox" size="medium" kendoCheckBox formControlName="oteval" />
                    <kendo-label class="k-checkbox-label" text="">
                      Occupational Therapy
                    </kendo-label>
                  </div>
                </div>
              </ng-container>
              <ng-container *ngIf="!isEdit">
                <div class="k-d-flex !k-flex-col gap-24">
                  <div>
                    <span class="text-secondary">Are you operating your approved MDE program?</span>
                    <p>{{entityData?.operatingMDE ? 'Yes' : 'No'}}</p>
                  </div>
                  <div>
                    <span class="text-secondary">Language of Service</span>
                    <p>{{entityData?.languageList}}</p>
                  </div>
                  <div>
                    <span class="text-secondary">Bilingual MDE Service Methods</span>
                    <p>
                      {{ commaSeparateValues([
                      { key: 'bilingualPsychologist', label: 'Bilingual Psychologist' },
                      { key: 'bilingualInterpreter', label: 'Through an Interpreter' }
                      ]) }}
                    </p>
                  </div>

                  <div>
                    <span class="text-secondary">Evaluation Setting</span>
                    <p>
                      {{ commaSeparateValues([
                      { key: 'onSite', label: 'On-Site' },
                      { key: 'offSite', label: 'Off-Site' }
                      ]) }}
                    </p>
                  </div>
                  <div>
                    <span class="text-secondary">Borough(s) Serviced </span>
                    <p>
                      {{ commaSeparateValues([
                      { key: 'serviceBronx', label: 'Bronx' },
                      { key: 'serviceBrooklyn', label: 'Brooklyn' },
                      { key: 'serviceManhattan', label: 'Manhattan' },
                      { key: 'serviceQueens', label: 'Queens' },
                      { key: 'serviceStatenIsland', label: 'Staten Island' }
                      ]) }}
                    </p>
                  </div>


                  <div>
                    <span class="text-secondary">Type of Evaluations</span>
                    <p>
                      {{ commaSeparateValues([
                      { key: 'sheval', label: 'Social History Evaluation' },
                      { key: 'psychoEval', label: 'Psychological Assessment' },
                      { key: 'counseling', label: 'Counseling' },
                      { key: 'pteval', label: 'Physical Therapy' },
                      { key: 'oteval', label: 'Occupational Therapy' }
                      ]) }}
                    </p>
                  </div>

                </div>

              </ng-container>
            </div>
          </kendo-tilelayout-item>
        </kendo-tilelayout>

      </div>


      <div class="action-panel" *ngIf="isEdit">
        <div class="action-btns">
          <button kendoButton type="button" themeColor="error" size="large" rounded="large" fillMode="outline"
            (click)="cancelEdit()">
            Cancel
          </button>
          <div class="action-btns__right">
            <button kendoButton themeColor="primary" size="large" rounded="large" fillMode="solid" (click)="save()"
              [disabled]="!isEdit">
              Save
            </button>
          </div>
        </div>
      </div>
    </div>
  </form>
</div>